import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconLock';
/** Renders an SVG icon. */
const SvgLock = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 9a6 6 0 0 1 12 0v3h2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4h2zm2 3h8V9a4 4 0 0 0-8 0zm-4 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm6.793 5.207a1.707 1.707 0 1 1 2.414 0l-.207.207V22a1 1 0 1 1-2 0v-2.586z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.793 16.793a1.707 1.707 0 1 1 2.414 2.414l-.207.207V22a1 1 0 1 1-2 0v-2.586l-.207-.207a1.707 1.707 0 0 1 0-2.414"
      />
    </svg>
  );
};
SvgLock.displayName = displayName;
export default SvgLock;
